import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '外包公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mainBusiness',
    fieldName: '主营业务'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'contactNumber',
    fieldName: '企业联系'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'address',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'addressDetail',
    fieldName: '详细地址'
  },
  // {
  //   componentType: 'el-upload',
  //   componentName: '输入框',
  //   fieldKey: 'certificatesPictures',
  //   fieldName: '证件照片'
  // }, {
  //   componentType: 'el-upload',
  //   componentName: '输入框',
  //   fieldKey: 'certificatesPdf',
  //   fieldName: '证件PDF'
  // },
  {
    componentType: 'el-textarea',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注信息'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'titleName',
    fieldName: '发票抬头'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'taxId',
    fieldName: '税号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'registeredAddress',
    fieldName: '注册地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'bank',
    fieldName: '开户银行'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '银行账号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '电话号码'
  }
]
